import { SET_ITEMS, SET_CATEGORIES } from './types';
import { Product, ProductCategory } from '../../types';

export function setItems(items: Product[]) {
  return {
    type: SET_ITEMS,
    payload: {
      items,
    },
  };
}

export function setCategories(categories: ProductCategory[]) {
  return {
    type: SET_CATEGORIES,
    payload: {
      categories,
    },
  };
}
